function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

var dispatchCustomEvent = function dispatchCustomEvent(eventName) {
  var data =
    arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var detail = {
    detail: data,
  };
  var event = new CustomEvent(eventName, data ? detail : null);
  document.dispatchEvent(event);
};

window.recentlyViewedIds = [];

/**
 *  @class
 *  @function Quantity
 */
if (!customElements.get("quantity-selector")) {
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector(".qty");
      this.step = this.input.getAttribute("step");
      this.changeEvent = new Event("change", {
        bubbles: true,
      });
      // Create buttons
      this.subtract = this.querySelector(".minus");
      this.add = this.querySelector(".plus");

      // Add functionality to buttons
      this.subtract.addEventListener("click", () =>
        this.change_quantity(-1 * this.step),
      );
      this.add.addEventListener("click", () =>
        this.change_quantity(1 * this.step),
      );
    }
    connectedCallback() {
      this.classList.add("buttons_added");
    }
    change_quantity(change) {
      // Get current value
      let quantity = Number(this.input.value);

      // Ensure quantity is a valid number
      if (isNaN(quantity)) quantity = 1;

      // Check for min & max
      if (this.input.getAttribute("min") > quantity + change) {
        return;
      }
      if (this.input.getAttribute("max")) {
        if (this.input.getAttribute("max") < quantity + change) {
          return;
        }
      }
      // Change quantity
      quantity += change;

      // Ensure quantity is always a number
      quantity = Math.max(quantity, 1);

      // Output number
      this.input.value = quantity;

      this.input.dispatchEvent(this.changeEvent);
    }
  }
  customElements.define("quantity-selector", QuantityInput);
}

/**
 *  @class
 *  @function ProductCard
 */
if (!customElements.get("product-card")) {
  class ProductCard extends HTMLElement {
    constructor() {
      super();
      this.swatches = this.querySelector(".product-card-swatches");
      this.image = this.querySelector(
        ".product-featured-image-link .product-primary-image",
      );
      this.secondary = this.querySelector(
        ".product-featured-image-link .product-secondary-image",
      );
      this.quick_add = this.querySelector(
        ".product-card--add-to-cart-button-simple",
      );
    }
    connectedCallback() {
      if (this.swatches) {
        this.enableSwatches();
      }
      if (this.quick_add) {
        this.enableQuickView();
      }
      if (this.secondary) {
        window.addEventListener("load", (event) => {
          lazySizes.loader.unveil(this.secondary);
        });
      }
    }
    enableSwatches() {
      let swatch_list = this.swatches.querySelectorAll(".product-card-swatch"),
        org_srcset = this.image ? this.image.dataset.srcset : "";

      swatch_list.forEach((swatch, index) => {
        window.addEventListener("load", (event) => {
          let image = new Image();
          image.srcset = swatch.dataset.srcset;
          lazySizes.loader.unveil(image);
        });
        swatch.addEventListener("mouseover", () => {
          [].forEach.call(swatch_list, function (el) {
            el.classList.remove("active");
          });
          if (this.image) {
            if (swatch.dataset.srcset) {
              this.image.setAttribute("srcset", swatch.dataset.srcset);
            } else {
              this.image.setAttribute("srcset", org_srcset);
            }
          }

          swatch.classList.add("active");
        });
        swatch.addEventListener("click", function (evt) {
          window.location.href = this.dataset.href;
          evt.preventDefault();
        });
      });
    }
    enableQuickView() {
      this.quick_add.addEventListener("click", this.quickAdd.bind(this));
    }

    quickAdd(evt) {
      evt.preventDefault();
      if (this.quick_add.disabled) {
        return;
      }
      this.quick_add.classList.add("loading");
      this.quick_add.setAttribute("aria-disabled", true);

      const config = {
        method: "POST",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          Accept: "application/javascript",
        },
      };

      let formData = new FormData(this.form);

      formData.append("id", this.quick_add.dataset.productId);
      formData.append("quantity", 1);
      formData.append(
        "sections",
        this.getSectionsToRender().map((section) => section.section),
      );
      formData.append("sections_url", window.location.pathname);

      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            return;
          }
          this.renderContents(response);

          dispatchCustomEvent("cart:item-added", {
            product: response.hasOwnProperty("items")
              ? response.items[0]
              : response,
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.quick_add.classList.remove("loading");
          this.quick_add.removeAttribute("aria-disabled");
        });

      return false;
    }
    getSectionsToRender() {
      return [
        {
          id: "Cart",
          section: "main-cart",
          selector: ".thb-cart-form",
        },
        {
          id: "Cart-Drawer",
          section: "cart-drawer",
          selector: ".cart-drawer",
        },
        {
          id: "cart-drawer-toggle",
          section: "cart-bubble",
          selector: ".thb-item-count",
        },
      ];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section) => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace =
          document.getElementById(section.id).querySelector(section.selector) ||
          document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.section],
          section.selector,
        );
        if (typeof CartDrawer !== "undefined") {
          new CartDrawer();
        }
        if (typeof Cart !== "undefined") {
          new Cart().renderContents(parsedState);
        }
      });

      if (document.getElementById("Cart-Drawer")) {
        document.getElementById("Cart-Drawer").open();
      }
    }
    getSectionInnerHTML(html, selector = ".shopify-section") {
      return new DOMParser()
        .parseFromString(html, "text/html")
        .querySelector(selector).innerHTML;
    }
  }
  customElements.define("product-card", ProductCard);
}

/**
 *  @class
 *  @function PanelClose
 */
class PanelClose extends HTMLElement {
  constructor() {
    super();
    let cc = document.querySelector(".click-capture");

    // Add functionality to buttons
    this.addEventListener("click", (e) => this.close_panel(e));
    document.addEventListener("keyup", (e) => {
      if (e.code) {
        if (e.code.toUpperCase() === "ESCAPE") {
          document.querySelectorAll(".side-panel").forEach((panel) => {
            panel.classList.remove("active");
            document.body.classList.remove("open-cc");
          });
        }
      }
    });
    cc.addEventListener("click", (e) => {
      document.body.classList.remove("open-cc");
      if (document.querySelector(".side-panel.active")) {
        document.querySelector(".side-panel.active").classList.remove("active");
      }
    });
  }

  close_panel(e) {
    e.preventDefault();
    let panel = e.target.closest(".side-panel");
    panel.classList.remove("active");
    document.body.classList.remove("open-cc");
  }
}
customElements.define("side-panel-close", PanelClose);

/**
 *  @class
 *  @function CartDrawer
 */
if (!customElements.get("cart-drawer")) {
  class CartDrawer extends HTMLElement {
    constructor() {
      super();
      this.removeProductEvent = this.removeProductEvent.bind(this);
    }

    connectedCallback() {
      let button = document.getElementById("cart-drawer-toggle");
      if (!button) {
        return;
      }
      // Add functionality to buttons
      button.addEventListener("click", (e) => {
        e.preventDefault();
        this.open();
      });

      this.debouncedOnChange = debounce((event) => {
        this.onChange(event);
      }, 300);

      document.addEventListener("cart:refresh", (event) => {
        this.refresh();
        setTimeout(() => {
          this.initializeVariantSelectors();
          this.initializeFormHandlers();
        }, 2000);
      });

      this.addEventListener("change", this.debouncedOnChange.bind(this));
      this.removeProductEvent();
      this.initializeVariantSelectors();
      this.initializeFormHandlers(); // Add initial form handlers
    }

    initializeFormHandlers() {
      const forms = this.querySelectorAll("form.add-to-cart-form");
      forms.forEach((form) => {
        form.onsubmit = async (e) => {
          e.preventDefault();
          try {
            const formData = new FormData(form);
            await fetch(window.Shopify.routes.root + "cart/add.js", {
              method: "POST",
              body: formData,
            });
            this.refresh();
            setTimeout(() => {
              this.initializeVariantSelectors();
              this.initializeFormHandlers();
            }, 2000);
          } catch (error) {
            console.error("Error adding to cart:", error);
          }
        };
      });
    }

    initializeVariantSelectors() {
      console.log("Initializing variant selectors");
      const selectors = this.querySelectorAll(
        "select[data-variant-selector], .variant-dropdown",
      );
      console.log("Found selectors:", selectors.length);
      selectors.forEach((selector) => {
        this.adjustSelectWidth(selector);
        selector.removeEventListener("change", this.handleVariantChange);
        selector.addEventListener("change", (e) => this.handleVariantChange(e));
      });
      const checkoutButton = document.querySelector(
        "cart-drawer .checkout-button",
      );
      
      if (checkoutButton) {
        checkoutButton.addEventListener("click", function () {
          this.classList.add("loading");

          setTimeout(() => {
            this.classList.remove("loading");
          }, 5000);
        });
      }
      this.removeProductEvent();
    }
    adjustSelectWidth(selectElement) {
      const selectedOption = selectElement.options[selectElement.selectedIndex];
      const tempElement = document.createElement("span");

      // Set up temp element with option text styling
      tempElement.style.visibility = "hidden";
      tempElement.style.position = "absolute";
      tempElement.style.fontFamily =
        window.getComputedStyle(selectElement).fontFamily;
      tempElement.style.fontSize =
        window.getComputedStyle(selectElement).fontSize;
      tempElement.style.fontWeight =
        window.getComputedStyle(selectElement).fontWeight;
      tempElement.textContent = selectedOption.text;

      document.body.appendChild(tempElement);
      const width = tempElement.offsetWidth + 30; // Add padding for the dropdown arrow
      selectElement.style.width = `${width}px`;
      selectElement.style.backgroundImage =
        "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'%3E%3Cpath d='M10.0001 12.4791C9.88897 12.4791 9.7848 12.4618 9.68758 12.4271C9.59036 12.3923 9.50008 12.3333 9.41675 12.25L5.58341 8.41665C5.43064 8.26387 5.35425 8.06942 5.35425 7.83331C5.35425 7.5972 5.43064 7.40276 5.58341 7.24998C5.73619 7.0972 5.93064 7.02081 6.16675 7.02081C6.40286 7.02081 6.5973 7.0972 6.75008 7.24998L10.0001 10.5L13.2501 7.24998C13.4029 7.0972 13.5973 7.02081 13.8334 7.02081C14.0695 7.02081 14.264 7.0972 14.4167 7.24998C14.5695 7.40276 14.6459 7.5972 14.6459 7.83331C14.6459 8.06942 14.5695 8.26387 14.4167 8.41665L10.5834 12.25C10.5001 12.3333 10.4098 12.3923 10.3126 12.4271C10.2154 12.4618 10.1112 12.4791 10.0001 12.4791Z' fill='%23404040'/%3E%3C/svg%3E\")";

      document.body.removeChild(tempElement);
    }

    handleVariantChange(event) {
      console.log("Variant change triggered");
      const selectedOption = event.target.options[event.target.selectedIndex];
      const productContainer = event.target.closest(".product-cart-item");

      if (!productContainer) return;
      this.adjustSelectWidth(event.target);

      // Only update image if not default product
      const imageContainer = productContainer.querySelector(
        ".product-cart-item-image",
      );
      const existingImage = imageContainer?.querySelector("img");
      if (existingImage && selectedOption.dataset.productImage) {
        existingImage.src = selectedOption.dataset.productImage;
        existingImage.srcset = `${selectedOption.dataset.productImage} 200w`;
      }

      // Update product title and URL
      const titleElement = productContainer.querySelector(
        ".product-cart-item-content .cart-product-link",
      );
      if (titleElement) {
        const shortName = selectedOption.dataset.productShort;
        const subtitle = selectedOption.dataset.productSubtitle;

        if (shortName && subtitle) {
          titleElement.innerHTML = `
              <div class="recomended-short h4">${shortName}</div>
            `;
        } else {
          titleElement.innerHTML = selectedOption.dataset.productTitle;
        }
        titleElement.href = selectedOption.dataset.productUrl;
        titleElement.title = selectedOption.dataset.productTitle;
      }

      // Update price
      const current_price = productContainer.querySelector(
        ".drawer-recommended-content .price ins .amount.discounted",
      );
      const compare_price = productContainer.querySelector(
        ".drawer-recommended-content .price del .amount",
      );
      if (current_price) {
        const priceHTML = `${selectedOption.dataset.productPrice}`;
        current_price.innerHTML = priceHTML;
      }
      if (compare_price) {
        const price_compare_HTML = `${selectedOption.dataset.productComparePrice}`;
        compare_price.innerHTML = price_compare_HTML;
        compare_price.parentElement.style.display = "block";
      }
      // Update form
      const form = productContainer.querySelector(
        ".drawer-recommended-content form.add-to-cart-form",
      );
      if (form) {
        const productHandle = selectedOption.dataset.productHandle;
        if (productHandle && productHandle !== form.dataset.currentHandle) {
          form.dataset.currentHandle = productHandle;
        }

        const addToCartButton = form.querySelector(".add-to-cart-button");
        if (addToCartButton) {
          addToCartButton.setAttribute(
            "aria-label",
            `Add ${selectedOption.dataset.productTitle}`,
          );
        }
      }
    }

    open() {
      document.body.classList.add("open-cc");
      this.classList.add("active");
      this.focus();
      this.removeProductEvent();
      dispatchCustomEvent("cart-drawer:open");
      setTimeout(() => {
        this.initializeFormHandlers();
        this.initializeVariantSelectors();
        this.removeProductEvent();
      }, 2000);
    }

    close() {
      document.body.classList.remove("open-cc");
      this.classList.remove("active");
    }

    onChange(event) {
      if (event.target.classList.contains("qty")) {
        this.updateQuantity(event.target.dataset.index, event.target.value);
      }
      setTimeout(() => {
      this.initializeFormHandlers();
      this.removeProductEvent();
    }, 2000);
    }
    removeProductEvent() {
      const removes = this.querySelectorAll(".remove");
      removes.forEach((remove) => {
        remove.removeEventListener("click", this.handleRemoveClick);
        remove.addEventListener("click", (event) => {
          event.preventDefault();
          this.updateQuantity(event.target.dataset.index, "0");
        });
      });
      setTimeout(() => {
          this.initializeFormHandlers();
        }, 2000);
    }

    getSectionsToRender() {
      return [
        {
          id: "Cart-Drawer",
          section: "cart-drawer",
          selector: ".cart-drawer",
        },
        {
          id: "cart-drawer-toggle",
          section: "cart-bubble",
          selector: ".thb-item-count",
        },
      ];
    }

    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, "text/html")
        .querySelector(selector).innerHTML;
    }

    updateQuantity(line, quantity) {
      const item = this.querySelector(`#CartDrawerItem-${line}`);
      if (item) {
        item.classList.add("thb-loading");
      }

      const body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname,
      });
      dispatchCustomEvent("line-item:change:start", {
        quantity: quantity,
      });
      fetch(`${theme.routes.cart_change_url}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body,
      })
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);

          this.getSectionsToRender().forEach((section) => {
            const elementToReplace =
              document
                .getElementById(section.id)
                .querySelector(section.selector) ||
              document.getElementById(section.id);

            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector,
            );
          });

          this.removeProductEvent();
          setTimeout(() => {
            this.initializeVariantSelectors();
            this.initializeFormHandlers();
          }, 2000);

          dispatchCustomEvent("line-item:change:end", {
            quantity: quantity,
            cart: parsedState,
          });

          if (item && item.length) {
            item.classList.remove("thb-loading");
          }
        })
        .catch(console.error);
    }

    refresh() {
      let sections = "cart-drawer,cart-bubble";
      fetch(`${window.location.pathname}?sections=${sections}`)
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);

          this.getSectionsToRender().forEach((section) => {
            const elementToReplace =
              document
                .getElementById(section.id)
                .querySelector(section.selector) ||
              document.getElementById(section.id);

            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState[section.section],
              section.selector,
            );
          });

          this.initializeVariantSelectors();
          this.removeProductEvent();
          this.initializeFormHandlers();
        })
        .catch(console.error);
    }
  }
  customElements.define("cart-drawer", CartDrawer);
}

/**
 *  @class
 *  @function QuickView
 */
if (!customElements.get("quick-view")) {
  class QuickView extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.cc = document.querySelector(".click-capture");
      this.drawer = document.getElementById("Product-Drawer");
      this.body = document.body;

      this.addEventListener("click", this.setupEventListener.bind(this));
      this.cc.addEventListener("click", this.setupCCEventListener.bind(this));
    }
    setupCCEventListener(e) {
      this.body.classList.remove("open-cc");
      this.drawer.classList.remove("active");
      this.drawer.querySelector("#Product-Drawer-Content").innerHTML = "";
    }
    setupEventListener(e) {
      e.preventDefault();
      let productHandle = this.dataset.productHandle,
        href = `${theme.routes.root_url}/products/${productHandle}?view=quick-view`;

      // remove double `/` in case shop might have /en or language in URL
      href = href.replace("//", "/");
      if (!href || !productHandle) {
        return;
      }
      if (this.classList.contains("loading")) {
        return;
      }
      this.classList.add("loading");
      fetch(href, {
        method: "GET",
      })
        .then((response) => {
          this.classList.remove("loading");
          return response.text();
        })
        .then((text) => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, "text/html")
            .querySelector("#Product-Drawer-Content").innerHTML;

          this.renderQuickview(sectionInnerHTML, href, productHandle);
        });
    }
    renderQuickview(sectionInnerHTML, href, productHandle) {
      if (sectionInnerHTML) {
        this.drawer.querySelector("#Product-Drawer-Content").innerHTML =
          sectionInnerHTML;

        let js_files = this.drawer
          .querySelector("#Product-Drawer-Content")
          .querySelectorAll("script");

        if (js_files.length > 0) {
          var head = document.getElementsByTagName("head")[0];
          js_files.forEach((js_file, i) => {
            let script = document.createElement("script");
            script.src = js_file.src;
            head.appendChild(script);
          });
        }

        setTimeout(() => {
          window.dispatchEvent(new Event("resize"));
          if (Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
          if (window.ProductModel) {
            window.ProductModel.loadShopifyXR();
          }
        }, 300);

        this.body.classList.add("open-cc");
        this.drawer.classList.add("active");
        this.drawer.querySelector(".side-panel-close").focus();

        dispatchCustomEvent("quick-view:open", {
          productUrl: href,
          productHandle: productHandle,
        });
      }
    }
  }
  customElements.define("quick-view", QuickView);
}

/**
 *  @class
 *  @function ProductRecommendations
 */
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }
  fetchProducts() {
    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const recommendations = html.querySelector("product-recommendations");

        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        this.classList.add("product-recommendations--loaded");
      })
      .catch((e) => {
        console.error(e);
      });
  }
  connectedCallback() {
    this.fetchProducts();
  }
}

customElements.define("product-recommendations", ProductRecommendations);

/**
 *  @class
 *  @function SelectWidth
 */
class SelectWidth {
  constructor() {
    let _this = this;
    // resize on initial load
    document.querySelectorAll(".resize-select").forEach(_this.resizeSelect);

    // delegated listener on change
    document.body.addEventListener("change", (e) => {
      if (
        e.target.matches(".resize-select") &&
        e.target.offsetParent !== null
      ) {
        _this.resizeSelect(e.target);
      }
    });
    window.addEventListener("resize.resize-select", function () {
      document.querySelectorAll(".resize-select").forEach(_this.resizeSelect);
    });
  }

  resizeSelect(sel) {
    let tempOption = document.createElement("option");
    tempOption.textContent = sel.selectedOptions[0].textContent;

    let tempSelect = document.createElement("select");
    tempSelect.style.visibility = "hidden";
    tempSelect.style.position = "fixed";
    tempSelect.appendChild(tempOption);

    sel.after(tempSelect);
    if (tempSelect.clientWidth > 0) {
      sel.style.width = `${+tempSelect.clientWidth + 12}px`;
    }
    tempSelect.remove();
  }
}

/**
 *  @class
 *  @function CollapsibleRow
 */
if (!customElements.get("collapsible-row")) {
  // https://css-tricks.com/how-to-animate-the-details-element/
  class CollapsibleRow extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector("details");
      this.summary = this.querySelector("summary");
      this.content = this.querySelector(".collapsible__content");

      // Store the animation object (so we can cancel it if needed)
      this.animation = null;
      // Store if the element is closing
      this.isClosing = false;
      // Store if the element is expanding
      this.isExpanding = false;
    }
    connectedCallback() {
      this.setListeners();
    }
    setListeners() {
      this.querySelector("summary").addEventListener("click", (e) =>
        this.onClick(e),
      );
    }
    prepareAnimations() {
      let _this = this,
        summary_height = this.querySelector("summary").offsetHeight,
        content_height = this.querySelector(
          ".collapsible__content",
        ).offsetHeight,
        initial_height = summary_height,
        final_height = summary_height + content_height;

      this.tl = false;
      this.tl = gsap.timeline({
        reversed: !_this.details.open,
        paused: true,
        inherit: false,
        ease: "none",
        onStart: function () {
          _this.details.open = true;
          _this.details.style.overflow = "hidden";
        },
        onReverseComplete: function () {
          _this.details.open = false;
          _this.details.style.overflow = "";
        },
      });

      this.tl.fromTo(
        _this.details,
        {
          height: function () {
            let h = Math.max(Math.max(initial_height, 0), 24);
            return h;
          },
          clearProps: "height",
        },
        {
          duration: 0.4,
          height: final_height,
          clearProps: "height",
        },
      );

      if (this.details.open) {
        this.tl.progress(1);
      }
    }
    instantClose() {
      this.tl.timeScale(10).reverse();
    }
    animateClose() {
      this.tl.timeScale(3).reverse();
    }
    animateOpen() {
      this.tl.timeScale(1).play();
    }
    onClick(e) {
      // Stop default behaviour from the browser
      e.preventDefault();
      // Add an overflow on the <details> to avoid content overflowing
      this.details.style.overflow = "hidden";
      // Check if the element is being closed or is already closed
      if (this.isClosing || !this.details.open) {
        this.open();
        // Check if the element is being openned or is already open
      } else if (this.isExpanding || this.details.open) {
        this.shrink();
      }
    }
    shrink() {
      // Set the element as "being closed"
      this.isClosing = true;

      // Store the current height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the height of the summary
      const endHeight = `${this.summary.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate(
        {
          // Set the keyframes from the startHeight to endHeight
          height: [startHeight, endHeight],
        },
        {
          duration: 250,
          easing: "ease",
        },
      );

      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(false);
      // If the animation is cancelled, isClosing variable is set to false
      this.animation.oncancel = () => (this.isClosing = false);
    }

    open() {
      // Apply a fixed height on the element
      this.details.style.height = `${this.details.offsetHeight}px`;
      // Force the [open] attribute on the details element
      this.details.open = true;
      // Wait for the next frame to call the expand function
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      // Set the element as "being expanding"
      this.isExpanding = true;
      // Get the current fixed height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the open height of the element (summary height + content height)
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate(
        {
          // Set the keyframes from the startHeight to endHeight
          height: [startHeight, endHeight],
        },
        {
          duration: 400,
          easing: "ease-out",
        },
      );
      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(true);
      // If the animation is cancelled, isExpanding variable is set to false
      this.animation.oncancel = () => (this.isExpanding = false);
    }

    onAnimationFinish(open) {
      // Set the open attribute based on the parameter
      this.details.open = open;
      // Clear the stored animation
      this.animation = null;
      // Reset isClosing & isExpanding
      this.isClosing = false;
      this.isExpanding = false;
      // Remove the overflow hidden and the fixed height
      this.details.style.height = this.details.style.overflow = "";
    }
  }
  customElements.define("collapsible-row", CollapsibleRow);
}

/**
 *  @function addIdToRecentlyViewed
 */
function addIdToRecentlyViewed(handle) {
  if (!handle) {
    let product = document.querySelector(".thb-product-detail");

    if (product) {
      handle = product.dataset.handle;
    }
  }
  if (!handle) {
    return;
  }
  if (window.localStorage) {
    let recentIds = window.localStorage.getItem("recently-viewed");
    if (recentIds != "undefined" && recentIds != null) {
      window.recentlyViewedIds = JSON.parse(recentIds);
    }
  }
  // Remove current product if already in recently viewed array
  var i = window.recentlyViewedIds.indexOf(handle);

  if (i > -1) {
    window.recentlyViewedIds.splice(i, 1);
  }

  // Add id to array
  window.recentlyViewedIds.unshift(handle);

  if (window.localStorage) {
    window.localStorage.setItem(
      "recently-viewed",
      JSON.stringify(window.recentlyViewedIds),
    );
  }
}

document.addEventListener("DOMContentLoaded", () => {
  if (typeof SelectWidth !== "undefined") {
    new SelectWidth();
  }
  if (typeof CartDrawer !== "undefined") {
    new CartDrawer();
  }
});


/**
 * PDP ATC Banner Handler
 * Handles variant selection and add to cart for current product and siblings
 */
class PDPAtcBanner {
  constructor() {
    this.banner = document.querySelector('.atc-banner-main');
    this.buyBox = document.querySelector('.template-product .product-information');
    this.isInitialized = false;
    this.init();
  }

  init() {
    this.bindEvents();
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        setTimeout(() => {
          this.initVisibilityObserver();
          this.syncInitialVariant();
        }, 100);
      });
    } else {
      setTimeout(() => {
        this.initVisibilityObserver();
        this.syncInitialVariant();
      }, 100);
    }
  }

  initVisibilityObserver() {
    if (!this.banner || !this.buyBox || this.isInitialized) return;
    
    this.isInitialized = true;
    
    const buyBoxRect = this.buyBox.getBoundingClientRect();
    const headerOffset = 80; 
    const isVisible = buyBoxRect.top <= headerOffset;
    
    if (isVisible) {
      this.hideBanner();
    }
    
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.hideBanner();
          } else {
            this.showBanner();
          }
        });
      },
      {
        root: null, 
        rootMargin: '-80px 0px 0px 0px', 
        threshold: 0
      }
    );
  
    this.observer.observe(this.buyBox);
  }

  showBanner() {
    if (this.banner && this.isInitialized) {
      this.banner.style.display = 'block';
      document.body.classList.add('atc-init');
    }
  }

  hideBanner() {
    if (this.banner && this.isInitialized) {
      this.banner.style.display = 'none';
      document.body.classList.remove('atc-init');
    }
  }

  destroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
    this.isInitialized = false;  
  }

  bindEvents() {
    document.addEventListener('click', (e) => {
      if (e.target.closest('.pdp-atc-banner')) {
        if (e.target.matches('.pdp-atc-dropdown') || e.target.closest('.pdp-atc-variant-selector')) {
          e.preventDefault();
          e.stopPropagation();
        }
        this.scrollToBuyBox();
      }
    });
    
    document.addEventListener('change', (e) => {
      if (e.target.matches('input[name="Size"]')) {
        this.syncBannerWithBuyBox(e.target);
      }
    });
  }

  scrollToBuyBox() {
    const buyBox = !document.body.classList.contains("template-product-playmat") ? document.querySelector("#id-siblings-group-selector") : document.querySelector('#pdp-buy-box');    
    if (buyBox) {
      buyBox.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'start' 
      });
    }
  }

  syncBannerWithBuyBox(radioInput) {
    const selectedSize = radioInput.value;
    const dropdown = document.querySelector('.pdp-atc-dropdown');
    
    if (!dropdown) return;
    
    const matchingOption = Array.from(dropdown.options).find(option => {
      return option.dataset.variantTitle === selectedSize;
    });
    
    if (matchingOption) {
      dropdown.value = matchingOption.value;
      this.updateBannerContent(matchingOption);
    }
  }

  syncInitialVariant() {
    const checkedRadio = document.querySelector('input[name="Size"]:checked');
    if (checkedRadio) {
      this.syncBannerWithBuyBox(checkedRadio);
    }
  }

  // Helper method to decode HTML entities in price strings
  decodePrice(priceString) {
    if (!priceString) return '';
    
    // Create a temporary div to decode HTML entities
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = priceString;
    
    // Extract just the text content, which will be the actual price
    return tempDiv.textContent || tempDiv.innerText || priceString;
  }

  updateBannerContent(selectedOption) {
    const atcItem = document.querySelector('.pdp-atc-item');
    if (!selectedOption || !atcItem) return;

    const productData = {
      handle: selectedOption.dataset.productHandle,
      title: selectedOption.dataset.productTitle,
      metaSalePrice: selectedOption.dataset.metaSalePrice,
      url: selectedOption.dataset.productUrl,
      image: selectedOption.dataset.productImage,
      price: selectedOption.dataset.productPrice,
      comparePrice: selectedOption.dataset.productComparePrice,
      shortName: selectedOption.dataset.productShort,
      subtitle: selectedOption.dataset.productSubtitle,
      variantId: selectedOption.value
    };

    // Update image if it exists
    const image = atcItem.querySelector('.pdp-atc-product-image');
    if (image && productData.image) {
      image.src = productData.image;
      image.alt = productData.title;
    }
  
    // Update title
    const titleElement = atcItem.querySelector('.pdp-atc-product-title');
    if (titleElement) {
      titleElement.textContent = productData.shortName || productData.title;
    }
  
    // Update prices with proper HTML entity decoding
    const pricesContainer = atcItem.querySelector('.pdp-atc-prices');
    if (pricesContainer && productData.price) {
      pricesContainer.innerHTML = '';
      
      const salePrice = document.createElement('span');
      salePrice.className = 'pdp-atc-sale-price';
      salePrice.textContent = this.decodePrice(productData.price); // Use decodePrice and textContent
      pricesContainer.appendChild(salePrice);
      
      let comparePriceToShow = null;
      if (productData.metaSalePrice) {
        comparePriceToShow = productData.metaSalePrice;
      } else if (productData.comparePrice) {
        comparePriceToShow = productData.comparePrice;
      }
      
      if (comparePriceToShow) {
        const comparePrice = document.createElement('span');
        comparePrice.className = 'pdp-atc-compare-price';
        comparePrice.textContent = this.decodePrice(comparePriceToShow); // Use decodePrice and textContent
        pricesContainer.appendChild(comparePrice);
      }
    }

    // Update add to cart button variant ID
    const addToCartBtn = atcItem.querySelector('.pdp-atc-add-btn');
    if (addToCartBtn) {
      addToCartBtn.dataset.variantId = productData.variantId;
    }
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('.pdp-atc-banner')) {
    new PDPAtcBanner();
  }
});

// Handle dynamic content loading (for section groups)
document.addEventListener('shopify:section:load', (e) => {
  if (e.target.querySelector('.pdp-atc-banner')) {
    new PDPAtcBanner();
  }
});


//  addon product js
if (!customElements.get("addon-quick-view")) {
  class AddonQuickView extends HTMLElement {
    constructor() {
      super();
    }
    
    connectedCallback() {
      this.cc = document.querySelector(".click-capture");
      this.drawer = document.getElementById("Product-Drawer");
      this.body = document.body;
      
      this.addEventListener("click", this.setupEventListener.bind(this));
      this.setupTitleImageClickListeners();

      
      // Setup click capture listener if it exists
      if (this.cc) {
        this.cc.addEventListener("click", this.setupCCEventListener.bind(this));
      }
    }
    // NEW: Method to add click listeners to title and image
setupTitleImageClickListeners() {
  const addonElement = this.closest('.addon-product-single');
  if (!addonElement) return;
  
  // Add click listener to title
  const titleElement = addonElement.querySelector('.addon-product-shortname');
  if (titleElement) {
    titleElement.style.cursor = 'pointer';
    titleElement.addEventListener('click', (e) => {
      e.preventDefault();
      this.setupEventListener(e);
    });
  }
  
  // Add click listener to image wrapper
  const imageWrapper = addonElement.querySelector('.addon-product-image-wrapper');
  if (imageWrapper) {
    imageWrapper.style.cursor = 'pointer';
    imageWrapper.addEventListener('click', (e) => {
      e.preventDefault();
      this.setupEventListener(e);
    });
  }
}
    
    setupCCEventListener(e) {
      this.body.classList.remove("open-cc");
      this.drawer.classList.remove("active");
      this.drawer.classList.remove("gallery-loaded");
      this.drawer.querySelector("#Product-Drawer-Content").innerHTML = "";
      this.body.classList.remove("addon_quick_view_enabled");
    }
    
    setupEventListener(e) {
      e.preventDefault();
      
      // Check if this addon is already selected
      const addonElement = this.closest('.addon-product-single');
      const isSelected = addonElement && addonElement.classList.contains('selected');
      
      if (isSelected) {
        // If already selected, unselect it
        this.unselectAddon();
        return;
      }
      
      // Otherwise, proceed with normal selection process
      const productHandle = this.dataset.productHandle;
      this.clickedAddonElement = addonElement;
      
      if (!productHandle) {
        console.error('Product handle not found');
        return;
      }
      
      if (this.classList.contains("loading")) {
        return;
      }

      this.openQuickView(productHandle);
    }
    
    unselectAddon() {
      const addonElement = this.closest('.addon-product-single');
      
      if (addonElement) {
        // Remove selected class
        addonElement.classList.remove('selected');
        
        // Reset data attributes to original values
        this.resetAddonToOriginalState(addonElement);
        
        console.log('Addon unselected:', addonElement);
      }
    }
    
    resetAddonToOriginalState(addonElement) {
      const currentProductId = addonElement.dataset.productId;
      const currentHasVariants = addonElement.dataset.hasVariants;
      
      // Reset button text and state only
      this.resetAddonButton(addonElement);
      
      if (currentHasVariants === 'true') {
        addonElement.classList.add('has-variants');
        addonElement.classList.remove('no-variants');
      } else {
        addonElement.classList.add('no-variants');
        addonElement.classList.remove('has-variants');
      }
    }
    
    resetAddonButton(addonElement) {
      const button = addonElement.querySelector('.addon-product-button');
      
      if (button) {
        const currentHasVariants = button.dataset.hasVariants;
        if (currentHasVariants === 'true') {
          button.textContent = 'Choose Color';
        } else {
          button.textContent = 'Choose Color';
        }
        
        button.classList.remove('selected');
      }
    }
    
    openQuickView(productHandle) {
      let href = `${theme.routes.root_url}/products/${productHandle}?view=addon-quick-view`;
    
      href = href.replace("//", "/");
      
      this.classList.add("loading");
      
      fetch(href, {
        method: "GET",
      })
        .then((response) => {
          this.classList.remove("loading");
          return response.text();
        })
        .then((text) => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, "text/html")
            .querySelector("#Product-Drawer-Content").innerHTML;

          this.renderQuickview(sectionInnerHTML, href, productHandle);
        })
        .catch((error) => {
          this.classList.remove("loading");
          console.error('Error loading quick view:', error);
        });
    }
    
    renderQuickview(sectionInnerHTML, href, productHandle) {
      this.drawer.classList.add("addon_quick_outer");
     
      if (sectionInnerHTML) {
        this.drawer.querySelector("#Product-Drawer-Content").innerHTML = sectionInnerHTML;

        let js_files = this.drawer
          .querySelector("#Product-Drawer-Content")
          .querySelectorAll("script");

        if (js_files.length > 0) {
          var head = document.getElementsByTagName("head")[0];
          js_files.forEach((js_file, i) => {
            let script = document.createElement("script");
            script.src = js_file.src;
            head.appendChild(script);
          });
        }

        // Set up the Select Add-on button and sibling handlers
        setTimeout(() => {
          this.setupSelectAddonButton();
          this.setupSiblingHandlers();
          
          window.dispatchEvent(new Event("resize"));
          if (Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
          if (window.ProductModel) {
            window.ProductModel.loadShopifyXR();
          }
        }, 300);

        this.body.classList.add("open-cc");
        this.drawer.classList.add("active");
        this.drawer.querySelector(".side-panel-close").focus();
        this.body.classList.add("addon_quick_view_enabled");

        // Dispatch custom event if dispatchCustomEvent function exists
        if (typeof dispatchCustomEvent === 'function') {
          dispatchCustomEvent("quick-view:open", {
            productUrl: href,
            productHandle: productHandle,
          });
        }
      }
       setTimeout(() => {
        this.drawer.classList.add('gallery-loaded');
      }, 700);
    }
    
    setupSelectAddonButton() {
    const selectAddonBtn = this.drawer.querySelector('.addon_buy_btn');
    
    if (selectAddonBtn) {
      const outOfStockBadge = this.drawer.querySelector('.addon_quick_main .badge.out-of-stock');
      
      if (outOfStockBadge) {
        selectAddonBtn.disabled = true;
        selectAddonBtn.classList.add('disabled');
        selectAddonBtn.textContent = 'Out of Stock';
      } else {
        selectAddonBtn.disabled = false;
        selectAddonBtn.classList.remove('disabled');
        selectAddonBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.handleSelectAddon();
        });
      }
    }
  }

    handleSelectAddon() {
      const selectedProduct = this.getSelectedProductInfo();
      
      if (selectedProduct) {
        this.closeModal();
        this.updateAddonContent(selectedProduct);
      }
    }

    getSelectedProductInfo() {
      const productElement = this.drawer.querySelector('.addon_quick_main');
      const productHandle = productElement ? productElement.dataset.handle : null;
      
      const shortnameElement = this.drawer.querySelector('.product-card-shortname');
      const subtitleElement = this.drawer.querySelector('.product-subtitle, .addon-product-subtitle');
      const regularTitleElement = this.drawer.querySelector('.product-title');
      
      let title = '';
      let shortname = '';
      let subtitle = '';
      
      if (shortnameElement) {
        shortname = shortnameElement.textContent.trim();
        title = shortname;
        
        if (subtitleElement) {
          subtitle = subtitleElement.textContent.trim();
          title = `${shortname} | ${subtitle}`;
        }
      } else if (regularTitleElement) {
        title = regularTitleElement.textContent.trim();
      }
      
      // Get selected variant ID and price
      let variantId = null;
      let price = '';
      let compareAtPrice = '';
      let variantText = '';
      // Check if there are variants
      const variantSelects = this.drawer.querySelector('variant-selects');
      const hasVariants = !!variantSelects;
      
      if (hasVariants) {
        // Has variants - get selected variant
        const hiddenInput = this.drawer.querySelector('input[name="id"]');
        variantId = hiddenInput ? hiddenInput.value : null;
        const formLabelValue = this.drawer.querySelector('.form__label__value');
        if (formLabelValue) {
          variantText = formLabelValue.textContent.trim();
        }
        
        // Get the currently selected variant's price from the checked radio button
        const selectedRadio = this.drawer.querySelector('input[type="radio"]:checked');
        if (selectedRadio) {
          const selectedLabel = this.drawer.querySelector(`label[for="${selectedRadio.id}"]`);
          if (selectedLabel) {
            const priceElement = selectedLabel.querySelector('.variant__info-price--current');
            if (priceElement) {
              price = priceElement.textContent.trim();
            }
          }
        }
        
        // Fallback: if no price found from radio button, try to get from variant data
        if (!price && variantId) {
          const variantScript = this.drawer.querySelector('script[type="application/json"]');
          if (variantScript) {
            try {
              const variants = JSON.parse(variantScript.textContent);
              const selectedVariant = variants.find(v => v.id.toString() === variantId);
              if (selectedVariant) {
                // Convert price from cents to dollars format
                price = `$${(selectedVariant.price / 100).toFixed(0)}`;
                if (selectedVariant.compare_at_price) {
                  compareAtPrice = `$${(selectedVariant.compare_at_price / 100).toFixed(0)}`;
                }
              }
            } catch (e) {
              console.error('Error parsing variant data:', e);
            }
          }
        }
      } else {
        // No variants - get default variant
        const hiddenInput = this.drawer.querySelector('input[name="id"]');
        variantId = hiddenInput ? hiddenInput.value : null;
        
        // Get price from price container
        const priceElement = this.drawer.querySelector('.amount.base-price');
        if (priceElement) {
          price = priceElement.textContent.trim();
        }
        
        // Check for compare at price
        const compareAtElement = this.drawer.querySelector('.compare-at-price');
        if (compareAtElement) {
          compareAtPrice = compareAtElement.textContent.trim();
        }
      }
      
      // Get product ID from form
      const productIdInput = this.drawer.querySelector('input[name="product-id"]');
      const productId = productIdInput ? productIdInput.value : null;
      
      // Get selected quantity
      const quantityInput = this.drawer.querySelector('input[name="quantity"]');
      const quantity = quantityInput ? quantityInput.value : '1';
      
      // Get featured image
      let featuredImage = '';
      const mainImage = this.drawer.querySelector('.product-single__media-image img');
      if (mainImage) {
        featuredImage = mainImage.src || mainImage.dataset.src;
        // Clean up the image URL to get a clean version
        if (featuredImage) {
          featuredImage = featuredImage.split('?')[0]; // Remove query parameters
        }
      }
      
      // Get description (if available)
      let description = '';
      const descElement = this.drawer.querySelector('.product-short-description, .addon-product-description p');
      if (descElement) {
        description = descElement.textContent.trim();
        // Limit to first 60 characters
        if (description.length > 60) {
          description = description.substring(0, 60) + '...';
        }
      }
      
      // Get selected color/option info from siblings if available
      let selectedOption = '';
      const activeSibling = this.drawer.querySelector('.product-sibling-item.active');
      if (activeSibling) {
        selectedOption = activeSibling.dataset.optionValue || '';
        if (selectedOption && subtitle === '') {
          subtitle = selectedOption;
          title = shortname ? `${shortname} | ${subtitle}` : `${title} | ${subtitle}`;
        }
      }
      
      console.log('Selected variant info:', {
        variantId: variantId,
        price: price,
        compareAtPrice: compareAtPrice,
        hasVariants: hasVariants
      });
      
      return {
        id: productId,
        handle: productHandle,
        title: title,
        shortname: shortname,
        subtitle: subtitle || selectedOption,
        variantId: variantId,
        variantText: variantText,
        quantity: quantity,
        price: price,
        compareAtPrice: compareAtPrice,
        featuredImage: featuredImage,
        description: description,
        hasVariants: hasVariants,
        selectedOption: selectedOption
      };
    }

    closeModal() {
      this.body.classList.remove("open-cc");
      this.drawer.classList.remove("active");
      this.drawer.classList.remove("gallery-loaded");
      this.body.classList.remove("addon_quick_view_enabled");
      this.drawer.querySelector("#Product-Drawer-Content").innerHTML = "";
    }

    updateAddonContent(selectedProduct) {
      if (this.clickedAddonElement) {
        // Don't store original values anymore - we want to keep the new selection as base
        
        // Add selected class
        this.clickedAddonElement.classList.add('selected');
        
        // Update data attributes with new product
        this.clickedAddonElement.setAttribute('data-product-id', selectedProduct.id);
        this.clickedAddonElement.setAttribute('data-variant-id', selectedProduct.variantId);
        this.clickedAddonElement.setAttribute('data-quantity', selectedProduct.quantity);
        this.clickedAddonElement.setAttribute('data-has-variants', selectedProduct.hasVariants ? 'true' : 'false');
        
        // Update classes based on variants
        if (selectedProduct.hasVariants) {
          this.clickedAddonElement.classList.add('has-variants');
          this.clickedAddonElement.classList.remove('no-variants');
        } else {
          this.clickedAddonElement.classList.add('no-variants');
          this.clickedAddonElement.classList.remove('has-variants');
        }
        
        // Update image
        this.updateAddonImage(selectedProduct);
        
        // Update title and links
        this.updateAddonTitle(selectedProduct);
        
        // Update price
        this.updateAddonPrice(selectedProduct);
        
        // Update button with new product data
        this.updateAddonButton(selectedProduct);

        this.updateAddonQuantity(selectedProduct);
        this.updateAddonVariant(selectedProduct); 
        
        // Update description if available
        this.updateAddonDescription(selectedProduct);
        
        console.log('Updated addon element:', this.clickedAddonElement);
        console.log('Selected product:', selectedProduct);
      }
    }

    updateAddonImage(selectedProduct) {
      const imageWrapper = this.clickedAddonElement.querySelector('.addon-product-image-wrapper');
      const link = imageWrapper.querySelector('.addon-product-link');
      
      if (link && selectedProduct.handle) {
        // Update link href
        link.href = `/products/${selectedProduct.handle}`;
        
        // Update image
        if (selectedProduct.featuredImage) {
          // Replace with new image
          link.innerHTML = `<img class="lazyautosizes ls-is-cached lazyloaded" 
            width="150" height="150" 
            src="${selectedProduct.featuredImage}?width=150" 
            alt="${selectedProduct.title}"
            sizes="80px">`;
        } else {
          // Fallback to placeholder
          link.innerHTML = `<div class="addon-product-placeholder">
            <svg><!-- placeholder svg --></svg>
          </div>`;
        }
      }
    }

    updateAddonVariant(selectedProduct) {
      const variantElement = this.clickedAddonElement.querySelector('.varaint-addon');
      
      if (variantElement) {
        const variantText = selectedProduct.variantText || '';
        variantElement.textContent = variantText;
        
        console.log('Updated variant display:', variantText); // Debug log
      }
    }

    updateAddonTitle(selectedProduct) {
    const titleWrapper = this.clickedAddonElement.querySelector('.addon-title-price-main');
    const link = titleWrapper.querySelector('.addon-product-link');
    
    if (link && selectedProduct.handle) {
      // Update link href
      link.href = `/products/${selectedProduct.handle}`;
      
      // Update title content - only shortname or title, NO subtitle in the link
      if (selectedProduct.shortname) {
        link.innerHTML = `
          <h4 class="addon-product-shortname">${selectedProduct.shortname}</h4>
        `;
      } else {
        link.innerHTML = `
          <h4 class="addon-product-title">${selectedProduct.title}</h4>
        `;
      }
    }
    
    // Update subtitle in the separate location outside the link
    const subtitleElement = this.clickedAddonElement.querySelector('.addon-product-subtitle');
    if (subtitleElement && selectedProduct.subtitle) {
      subtitleElement.textContent = selectedProduct.subtitle;
    } else if (subtitleElement) {
      // Clear subtitle if no subtitle available
      subtitleElement.textContent = '';
    }
  }
    updateAddonQuantity(selectedProduct) {
    const qtyElement = this.clickedAddonElement.querySelector('.selected-addon-subtitle-qty .qty');
    
    if (qtyElement && selectedProduct.quantity) {
      // Display quantity (e.g., "Qty: 2" or just "2")
      qtyElement.textContent = `Qty: ${selectedProduct.quantity}`;
    } else if (qtyElement) {
      // Clear quantity if no quantity available
      qtyElement.textContent = '';
    }
  }

    updateAddonPrice(selectedProduct) {
      const priceWrapper = this.clickedAddonElement.querySelector('.addon-product-price-wrapper');
      
      if (priceWrapper) {
        if (selectedProduct.compareAtPrice && selectedProduct.compareAtPrice > selectedProduct.price) {
          // Has compare at price
          priceWrapper.innerHTML = `
            <span class="addon-product-price">${selectedProduct.price}</span>
            <span class="addon-product-compare-price">${selectedProduct.compareAtPrice}</span>
          `;
        } else {
          // Regular price only
          priceWrapper.innerHTML = `
            <span class="addon-product-price">${selectedProduct.price}</span>
          `;
        }
      }
    }

    updateAddonButton(selectedProduct) {
      const button = this.clickedAddonElement.querySelector('.addon-product-button');
      
      if (button) {
        // Update button attributes with NEW product data (not original)
        button.setAttribute('data-product-handle', selectedProduct.handle);
        button.setAttribute('data-product-id', selectedProduct.id);
        button.setAttribute('data-variant-id', selectedProduct.variantId);
        button.setAttribute('data-quantity', selectedProduct.quantity);
        
        if (selectedProduct.hasVariants) {
          button.setAttribute('data-has-variants', 'true');
        } else {
          button.removeAttribute('data-has-variants');
        }
        
        // Always set to "✓ Selected" after selection
        button.textContent = '✓ Selected';
        button.classList.add('selected');
      }
    }

    updateAddonDescription(selectedProduct) {
      const descriptionWrapper = this.clickedAddonElement.querySelector('.addon-product-description');
      
      if (descriptionWrapper && selectedProduct.description) {
        const descriptionP = descriptionWrapper.querySelector('p');
        if (descriptionP) {
          descriptionP.textContent = selectedProduct.description;
        }
      }
    }
    
    // Helper method to get all selected addon data for cart operations
    getSelectedAddonData(addonElement = null) {
      const element = addonElement || this.closest('.addon-product-single');
      
      if (!element || !element.classList.contains('selected')) {
        return null;
      }
      
      return {
        productId: element.dataset.productId,
        variantId: element.dataset.variantId,
        quantity: element.dataset.quantity,
        hasVariants: element.dataset.hasVariants === 'true',
        handle: element.querySelector('.addon-product-button')?.dataset.productHandle
      };
    }
    
    setupSiblingHandlers() {
      // Look for sibling items in the quick view
      const siblingItems = this.drawer.querySelectorAll('.addon_quick_main .product-sibling-item');
      
      if (siblingItems.length > 0) {
        console.log(`Found ${siblingItems.length} sibling items`);
        
        siblingItems.forEach(siblingItem => {
          // Remove existing click handlers and prevent default navigation
          siblingItem.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            
            const productHandle = siblingItem.dataset.productHandle;
            const productId = siblingItem.dataset.productId;
            const hasVariants = siblingItem.dataset.hasVariants === 'true';
            const optionValue = siblingItem.dataset.optionValue;
            
            console.log(`Sibling clicked: ${optionValue} (Handle: ${productHandle})`);
            
            // Don't do anything if clicking the active sibling
            if (siblingItem.classList.contains('active')) {
              console.log('Active sibling clicked, ignoring');
              return;
            }
            
            // Close current quick view and open new one
            this.switchToSibling(productHandle, optionValue);
          });
        });
      }
    }
    
    switchToSibling(newProductHandle, optionValue) {
      console.log(`Switching to sibling: ${optionValue} (${newProductHandle})`);
      
      // Add loading state to the drawer
      this.drawer.classList.add('switching-sibling');
      this.drawer.classList.remove('gallery-loaded');
      
      // Clear current content with a slight delay for smooth transition
      setTimeout(() => {
        this.drawer.querySelector("#Product-Drawer-Content").innerHTML = '';
        
        // Load new sibling product
        this.loadSiblingProduct(newProductHandle);
      }, 150);
    }
    
    loadSiblingProduct(productHandle) {
      let href = `${theme.routes.root_url}/products/${productHandle}?view=addon-quick-view`;
      
      // Remove double `/` in case shop might have /en or language in URL
      href = href.replace("//", "/");
      
      fetch(href, {
        method: "GET",
      })
        .then((response) => {
          return response.text();
        })
        .then((text) => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, "text/html")
            .querySelector("#Product-Drawer-Content").innerHTML;

          this.renderSiblingQuickview(sectionInnerHTML, href, productHandle);
        })
        .catch((error) => {
          console.error('Error loading sibling product:', error);
          // Remove loading state on error
          this.drawer.classList.remove('switching-sibling');
        });
    }
    
    renderSiblingQuickview(sectionInnerHTML, href, productHandle) {
      if (sectionInnerHTML) {
        this.drawer.querySelector("#Product-Drawer-Content").innerHTML = sectionInnerHTML;
         setTimeout(() => {
            this.drawer.classList.add('gallery-loaded');
          }, 700);
        let js_files = this.drawer
          .querySelector("#Product-Drawer-Content")
          .querySelectorAll("script");

        if (js_files.length > 0) {
          var head = document.getElementsByTagName("head")[0];
          js_files.forEach((js_file, i) => {
            let script = document.createElement("script");
            script.src = js_file.src;
            head.appendChild(script);
          });
        }

        // Setup sibling click handlers and select addon button for the new content
        setTimeout(() => {
          this.setupSelectAddonButton();
          this.setupSiblingHandlers();
          
          // Remove switching state
          this.drawer.classList.remove('switching-sibling');
          
          window.dispatchEvent(new Event("resize"));
          if (Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
          if (window.ProductModel) {
            window.ProductModel.loadShopifyXR();
          }
        }, 300);

        // Dispatch custom event for sibling switch
        if (typeof dispatchCustomEvent === 'function') {
          dispatchCustomEvent("quick-view:sibling-switched", {
            productUrl: href,
            productHandle: productHandle,
          });
        }
      }
    }
  }
  
  customElements.define("addon-quick-view", AddonQuickView);
}



// temporary Js fixes 

document.addEventListener("DOMContentLoaded", () => {
  if (document.documentElement.lang === "de" &&  document.body.classList.contains("template-page-whole-sale")) {
    const updateHeading = () => {
      console.log("I am running")
      const host = document.querySelector("shopify-forms-embed");
      if (!host || !host.shadowRoot) return false;

      const heading = host.shadowRoot.querySelector("h2._textHeading_2aowh_35");
      if (heading && heading.textContent.includes("GROßHANDEL")) {
        heading.textContent = "GROßHANDEL & VERTRIEB"; // Fix encoded ampersand
        return true;
      }
      return false;
    };

    if (!updateHeading()) {
      const observer = new MutationObserver(() => {
        if (updateHeading()) observer.disconnect();
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }
});


document.addEventListener("DOMContentLoaded", () => {
  // Run only for German pages
  if (document.documentElement.lang === "de") {
    /** ---------- 1️⃣ Update Shopify form heading inside Shadow DOM ---------- **/
    const updateShopifyFormHeading = () => {
      const host = document.querySelector("shopify-forms-embed");
      if (!host || !host.shadowRoot) return false;

      const heading = host.shadowRoot.querySelector("h2._textHeading_2aowh_35");
      if (heading && heading.textContent.includes("GROßHANDEL")) {
        heading.textContent = "GROßHANDEL & VERTRIEB";
        return true;
      }
      return false;
    };

    if (!updateShopifyFormHeading()) {
      const observer1 = new MutationObserver(() => {
        if (updateShopifyFormHeading()) observer1.disconnect();
      });
      observer1.observe(document.body, { childList: true, subtree: true });
    }

    /** ---------- 2️⃣ Update Gorgias Chat button inside iframe ---------- **/
    const updateChatHeading = () => {
      const iframe = document.querySelector("iframe#gorgias-chat-button, iframe#chat-button");
      if (!iframe) return false;

      try {
        const innerDoc = iframe.contentDocument || iframe.contentWindow.document;
        if (!innerDoc) return false;

        const heading = innerDoc.querySelector("h2.messenger-button-iframe-bzxdgz");
        if (heading && heading.textContent.includes("Chat with us")) {
          heading.textContent = "Lass dich beraten"; 
          return true;
        }
      } catch (e) {
  
      }

      return false;
    };

    if (!updateChatHeading()) {
      const observer2 = new MutationObserver(() => {
        if (updateChatHeading()) observer2.disconnect();
      });
      observer2.observe(document.body, { childList: true, subtree: true });
    }
  }
});


document.addEventListener("DOMContentLoaded", () => {

if (document.documentElement.lang === "de") {
    const updateGorgiasChatHeading = () => {
      const iframe = document.querySelector("iframe#chat-button");
      if (!iframe) return false;

      try {
    
        const innerDoc = iframe.contentDocument || iframe.contentWindow.document;
        if (!innerDoc) return false;


        const heading = innerDoc.querySelector("h2.messenger-button-iframe-1ov50v4");
        if (heading && heading.textContent.trim() === "Chat with us") {
          heading.textContent = "Lass dich beraten";  
          return true;
        }
      } catch (e) {

        console.warn("Unable to access Gorgias chat iframe:", e);
      }

      return false;
    };

    if (!updateGorgiasChatHeading()) {

      const observer = new MutationObserver(() => {
        if (updateGorgiasChatHeading()) observer.disconnect();
      });

      observer.observe(document.body, { childList: true, subtree: true });
    }
  }
});

// slider mobile initilization
document.addEventListener('DOMContentLoaded', function() {
  const mobileToggle = document.querySelector('.mobile-toggle-wrapper');
  const initializedSliders = new Set();
  
  mobileToggle.addEventListener('click', function() {
    setTimeout(function() {
      initializeSliders();
      setTimeout(function() {
        initializeSliders();
      }, 1000); 
    }, 500); 
  });
  
  function initializeSliders() {
    const sliders = document.querySelectorAll('.mega-productlist-main-sm');
    
    sliders.forEach(function(slider) {
      if (!initializedSliders.has(slider) && !slider.classList.contains('flickity-enabled')) {
        new Flickity(slider, {
          cellAlign: 'left',
          contain: true,
          prevNextButtons: true,
          pageDots: false,
          autoPlay: false,
          draggable: true,
          friction: 0.8
        });
        initializedSliders.add(slider);
        console.log('Mobile slider initialized at ' + new Date().toLocaleTimeString());
      }
    });
  }
});

